<script setup lang="ts">
defineProps<{
  disabled?: boolean
  isMobileVersion?: boolean
  suggestions: string[]
}>()

const emit = defineEmits<{
  select: [suggestion: string]
}>()
</script>

<template>
  <div class="flex min-h-0 flex-wrap gap-1 overflow-hidden print:hidden" :class="isMobileVersion ? 'max-w-full' : 'max-w-[80%]'">
    <button
      v-for="suggestion in suggestions"
      :key="suggestion"
      class="px-2.5 py-1 rounded-lg text-left text-sm bg-new-neutral-0 text-new-neutral-700 hover:text-new-secondary-default disabled:cursor-not-allowed disabled:opacity-50"
      :disabled="disabled"
      type="button"
      @click="emit('select', suggestion)"
    >
      {{ suggestion }}
    </button>
  </div>
</template>
